import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth.store.js';
import Layout from './components/Layout.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Login from './pages/Login.jsx';
import Activate from './pages/Activate.jsx';
import Setup from './pages/Setup.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clients from './pages/Clients.jsx';
import ClientDetail from './pages/ClientDetail.jsx';
import ApiKeys from './pages/ApiKeys.jsx';
import ClientMpMap from './pages/ClientMpMap.jsx';
import Stores from './pages/Stores.jsx';
import StoreDetail from './pages/StoreDetail.jsx';
import Terminals from './pages/Terminals.jsx';
import Users from './pages/Users.jsx';
import Settings from './pages/Settings.jsx';
import Orders from './pages/Orders.jsx';
import Logs from './pages/Logs.jsx';

function AuthOnly({ children }) {
  const { user, accessToken } = useAuthStore();
  if (!accessToken || !user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"    element={<Login />} />
      <Route path="/activate" element={<Activate />} />
      <Route path="/setup"    element={<AuthOnly><Setup /></AuthOnly>} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/clients" element={<ProtectedRoute roles={['superadmin']}><Clients /></ProtectedRoute>} />
        <Route path="/clients/:id" element={<ProtectedRoute roles={['superadmin']}><ClientDetail /></ProtectedRoute>} />
        <Route path="/clients/:id/api-keys" element={<ProtectedRoute roles={['superadmin']}><ApiKeys /></ProtectedRoute>} />
        <Route path="/clients/:id/mp-map" element={<ProtectedRoute roles={['superadmin']}><ClientMpMap /></ProtectedRoute>} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/stores/:id" element={<StoreDetail />} />
        <Route path="/terminals" element={<Terminals />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/logs" element={<Logs />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<ProtectedRoute roles={['superadmin']}><Settings /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
